<div class="cva-dialog-wrapper">
  <div class="dialog-header d-flex align-items-center justify-content-between" [ngClass]="headerClass">
    <h2>
      <mat-icon *ngIf="headerIcon" class="dialog-header-icon">{{ headerIcon }}</mat-icon>
      {{ title }}
      <cva-manual-refresh *ngIf="refreshIcon" [id]="id" [identifier]="indentifier"  (dataFetched)="patchRefreshedData($event)"></cva-manual-refresh>
    </h2>
    <button type="button" mat-icon-button aria-label="close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <ng-content></ng-content>
  </mat-dialog-content>
</div>
